<template>
  <div class="forum">
      <div class="inner">
        <div class="pub-title">
          <span>{{ $t("forum") }}</span>
        </div>
        <select-title :data="data" @params="setParams" @clickSearch="clickSearch"></select-title>
        <tabs :data="tabs" class="tabs pc" v-if="isPc" :active.sync="active" @click="clickTab"></tabs>
        <waic-tabs :data="tabs" class="tabs" v-else id="wap" width="1.62rem" :active.sync="active" @click="clickTab"></waic-tabs>
        <div class="forum2">
          <ul>
            <li v-for="(item, index) in list" :key="index" @click="showForum(item, index)">
              <div class="item-left">
                <big v-html="turnNum(`${item.startTime}-${item.endTime}`)"></big>
                <small>{{ item['typeValue' + En] }}</small>
              </div>
              <div class="item-mid">
                <big>{{ item['name' + En] }}</big>
                <p class="ellipsis2">{{ item['desc' + En] }}</p>
                <small><img src="https://static.worldaic.com.cn/2024/web/static/images/addr.png" alt=""> <span class="ellipsis1">{{ item['addr' + En] }}</span></small>
              </div>
              <div class="item-right" v-if="playSts(item.playSts)">
                <p>
                  <img v-if="item.playSts == 1" src="https://static.worldaic.com.cn/2024/web/static/images/zhibo-active.png" alt="">
                  <img v-else src="https://static.worldaic.com.cn/2024/web/static/images/zhibo.png" alt="">
                  <span class="pc">{{ playSts(item.playSts) }}</span>
                </p>
              </div>
            </li>
          </ul>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :layout="pageLayout"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <waic-banner code="h5_forum_detail_advert" :data="banners.forum" v-if="banners.forum && banners.forum.length"></waic-banner>
      <meetDialog
        :showMeetModal.sync="showMeetModal"
        :uuid.sync="uuid"
      ></meetDialog>
  </div>
</template>

<script>
import protal from "@/api/protal";
import tabs from './tabs.vue'
import moment from 'moment'
import meetDialog from "@/components/meetDialog.vue";

export default {
  components: {
    tabs,
    meetDialog
  },
  name: 'forum',
  data() {
    return {
      data: [],
      list: [],
      currentPage: 0,
      tabs: [],
      active: 0,
      dateList: [],
      allForumList: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      showMeetModal: false,
      uuid: '',
      times: [],
      params: {}
    }
  },
  async created() {
    this.pageView('gw_luntanpage')
    await this.getSearch()
    this.getData()
  },
  methods: {
    clickTab() {
      this.currentPage = 0
      this.pageNum = 1
      this.clickSearch({ typeName: '内容日期', name: this.tabs[this.active] })
      this.getForumData()
    },
    clickSearch(obj) {
      this.$jsAPI('track','highForumFilter',
          {
            'filterType_var': obj.typeName,
            'filterName_var': obj.name
          }
      );
      gio('track','highForumFilter',
          {
            'filterType_var': obj.typeName,
            'filterName_var': obj.name
          }
      );
        console.log('highForumFilter', {
          'filterType_var': obj.typeName,
          'filterName_var': obj.name
        })
    },
    getSearch() {
      return protal.queryOfficialPreviousForumType().then(res => {
        const arr = res.data || []
        const obj = arr.pop()
        obj.types.shift()
        this.times = obj.types
        this.tabs = this.times.map(x => x['name' + this.En])
        this.data = arr
      })
    },
    async showForum(item, index) {
      // console.log(item.dataTagRes, '标签')
      // let arr = item.dataTagRes || []
      // arr = arr.map(x => x.dataTag)
      // let industryFirstCate_var = this.labels.filter(x => arr.includes(x.uuid)).map(x => x.lableDesc).join('|')
      this.$jsAPI('track','highForumContent',
          {
            'forumname_var': item.name,
            'position_var': `${this.pageNum}-${index + 1}`,
            'contentDate_var': this.tabs[this.active],
            'forumType_var': item.typeValue,
            'forumSection_var': item.forumTag,
            'forumLocation_var': item.addr,
            'pagination_var': this.pageNum + '',
            // 'industryFirstCate_var': industryFirstCate_var ? '|' + industryFirstCate_var + '|' : '无',
            // 'industrySecCate_var': '无',
            'industryFirstCate_var': this.getFirstLabel(item.dataTagTwoRes),
            'industrySecCate_var': await this.getSecLabel(item.dataTagTwoRes),
            'liveStatus_var': this.$t('play' + item.playSts),
            'forumid_var': item.uuid
          }
      );

      gio('track','highForumContent',
          {
            'contentName_var': item.name || '无',
            'position_var': `${this.pageNum}-${index + 1}`,
            'contentDate_var': this.tabs[this.active],
            'forumType_var': item.typeValue || '无',
            'forumSection_var': item.forumTag || '无',
            'forumLocation_var': item.addr || '无',
            'pagination_var': this.pageNum + '',
            'industryCate_var': this.getFirstLabel(item.dataTagTwoRes),
            'industryFirstCate_var': await this.getSecLabel(item.dataTagTwoRes),
            'liveStatus_var': this.$t('play' + item.playSts),
          }
      );

      this.showMeetModal = true
      this.uuid = item.uuid
    },
    handleCurrentChange(v) {
      this.pageNum = v
      this.getForumData()
    },
    async getData() {
      await protal.getJson("home_forum", (data) => {
          this.dateList = data;
          this.dateList = this.dateList.map(x => {
            x.timeVal = x.date
            x.uuid = x.timeId
            return x
          })
          this.date = this.dateList[0].uuid;
          // this.tabs = this.dateList.map(x => x.timeVal)
      });
      this.getForumData();
    },
    setParams(params) {
      if (params.hideTime) {
        // this.active = -1
      }
      this.getForumData(params)
    },
    getForumData(obj) {
      if (obj && obj.hideTime) {
        delete obj.hideTime
      }
      let params = {
        forumTime: this.active != -1 ? this.times[this.active].ids : null,
        yearUuid: this.active != -1 ? this.dateList[0].yearUuid : '',
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      if (obj) {
        params = {...params, ...obj}
        params.pageNum = 1
        this.pageNum = 1
        this.params = JSON.parse(JSON.stringify(obj))
      } else {
        params = {...params, ...this.params}
      }

      protal.queryForumList(params).then((res) => {
        this.total = res.total || 0
        if (res && res.data) {
          this.list = res.data
        } else {
          this.list = []
        }
      });
    },
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .forum {
    padding: 1.65rem 0 1.26rem;
    background: url(https://static.worldaic.com.cn/2024/web/static/images/dahui-bg.jpg);
    background-size: 100% auto;

    .inner {
      width: 14.2rem;
      margin: 0 auto;
    }

    .tabs {
      margin-top: 0;
      margin-bottom: .1rem;
    }

    .content {
      margin-top: .4rem;
    }

    .forum2 {

      ul {
        width: 15rem;
        margin-left: -0.4rem;

        li {
          position: relative;
          display: flex;
          padding: .29rem .48rem .27rem .4rem;
          border-bottom: 1px solid #B4B4B5;
          width: 100%;
          cursor: pointer;

          .item-left {
            width: 2.34rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            big {
              display: block;
              font-size: .44rem;
              font-weight: 300;
              color: #595757;
              line-height: 1;
              height: .44rem;
            }

            small {
              display: block;
              font-size: .18rem;
              font-weight: 400;
              color: #595757;
              line-height: 1;
            }
          }

          .item-mid {
            flex: 1;
            overflow: hidden;
            margin-top: -0.05rem;
            margin-right: 1.2rem;

            big {
              font-family: sybold;
              font-size: .26rem;
              font-weight: normal;
              color: #595757;
              line-height: .44rem;
            }

            p {
              margin-top: 0.06rem;
              font-size: .16rem;
              color: #807D7D;
              line-height: .24rem;
            }

            small {
              display: flex;
              align-items: center;
              font-size: .18rem;
              color: #595757;
              line-height: .2rem;
              margin-top: .12rem;

              img {
                width: .2rem;
                height: .2rem;
              }
            }
          }

          .item-right {
            position: absolute;
            left: calc(100% - 1.4rem);
            display: flex;
            justify-content: flex-end;
            
            p {
              display: flex;
              align-items: center;
              text-align: right;
              font-size: .18rem;
              font-weight: 400;
              color: #727171;
              line-height: 1;
              height: .2rem;
              cursor: pointer;

              img {
                width: auto;
                height: .2rem;
                margin-right: .08rem;
              }
            }
          }
        }
      }
    }
    
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .forum {
    width: 100%;
    padding: 1.57rem 0 1.3rem;
    background: url(https://static.worldaic.com.cn/2024/web/static/images/wap-bg.jpg);
    background-size: 100% auto;
    overflow: hidden;

    .inner {
      width: 6.7rem;
      margin: 0 auto;
    }

    .search {
      margin-top: .47rem;

      /deep/ .el-input__inner {
        background-color: transparent;
        height: .56rem;
        background: rgba(255, 255, 255, 0.4);
        border-radius: .06rem;
        border: 1px solid rgba(47, 154, 244, 0.2);
        // border-image: linear-gradient(126deg, rgba(47, 154, 244, 0.6), rgba(195, 4, 226, 0.6)) 1 1;
      }

      /deep/ .el-input__suffix {
        display: flex;
        align-items: center;
        margin-right: .2rem;

        img {
          width: .26rem;
          height: .26rem;
        }
      }
    }

    .tabs {
      margin-top: .47rem;
      margin-bottom: .1rem;
    }

    .content {
      margin-top: .4rem;
    }

    .forum2 {

      ul {

        li {
          display: flex;
          padding: .3rem 0;
          border-bottom: 1px solid #B4B4B5;
          cursor: pointer;

          .item-left {
            width: 1.8rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            big {
              display: block;
              font-size: .3rem;
              font-weight: 300;
              color: #595757;
              line-height: .3rem;
            }

            small {
              display: block;
              font-size: .22rem;
              font-weight: 400;
              color: #595757;
              line-height: 1;
            }
          }

          .item-mid {
            width: 4rem;
            overflow: hidden;
            margin-top: -0.04rem;

            big {
              font-family: sybold;
              font-size: .28rem;
              color: #595757;
              line-height: .36rem;
            }

            p {
              font-size: .22rem;
              font-weight: 400;
              color: #807D7D;
              line-height: .3rem;
              margin-top: .15rem;
            }

            small {
              display: flex;
              align-items: center;
              font-size: .24rem;
              color: #595757;
              line-height: 1;
              margin-top: .16rem;

              img {
                width: .22rem;
                height: auto;
              }
            }
          }

          .item-right {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            margin-top: -0.02rem;
            
            p {
              display: flex;
              align-items: center;
              text-align: right;
              font-size: .24rem;
              font-weight: 400;
              color: #727171;
              line-height: .36rem;
              height: .36rem;
              cursor: pointer;

              img {
                width: auto;
                height: .28rem;
              }
            }
          }
        }
      }
    }
    
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/forum/index.vue